import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import CurrentUserContext from 'providers/CurrentUser';
import InputFieldComponent from 'components/InputField';
import api from 'api';
import { User } from 'models/User';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';

import './PersonalInfo.styles.scss';
import './PersonalInfo.styles.responsive.scss';

type PersonalInfoProps = {
  className?: string;
};

type PersonalInfoForm = Pick<User, 'firstName' | 'lastName'>;

const PersonalInfo: React.FC<PersonalInfoProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();
  const { user, updateUser } = useContext(CurrentUserContext);
  const { popError, popSuccess } = useContext(PopNotificationsContext);

  const classes = classNames('personal-info', className);

  const handleSaveUser = useCallback(
    async (values: PersonalInfoForm) => {
      const { firstName, lastName } = values;

      try {
        const { data } = await api.user.patchUser({
          firstName,
          lastName,
        });
        updateUser(data);
        popSuccess(t('data-updated-success'));
      } catch (error) {
        console.error(error);
        popError(t('data-updated-error'));
      }
    },
    [popError, popSuccess, t, updateUser],
  );

  return (
    <div className={classes}>
      <Form<PersonalInfoForm>
        onSubmit={handleSaveUser}
        initialValues={{ firstName: user.firstName, lastName: user.lastName }}
        render={({ handleSubmit, submitting, valid, dirty }) => {
          return (
            <form
              onSubmit={handleSubmit}
              className="personal-info__form"
              autoComplete="off"
            >
              <Field
                name="firstName"
                component={InputFieldComponent}
                label={t('first-name-label')}
                placeholder={t('first-name-placeholder')}
                required
              />
              <Field
                name="lastName"
                component={InputFieldComponent}
                label={t('last-name-label')}
                placeholder={t('last-name-placeholder')}
                required
              />

              {dirty && (
                <Button type="submit" disabled={submitting || !valid}>
                  {t('save')}
                </Button>
              )}
            </form>
          );
        }}
      />
    </div>
  );
};

export default PersonalInfo;
